module.exports = __webpack_public_path__ + "static/media/S-2-Y.a4460dac.mp3";